/**
  * login模块接口列表
  */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例

const loginApi = {
    Login: `${base.sq}/Login/Login`,
    Logout: `${base.sq}/Login/LogOut`
}

const login = {
    login (params) {
        console.log(params);
        return axios.post(loginApi.Login, params)
    },
    logout () {
        return axios.post(loginApi.Logout)
    }
}


export default login;